
(()=>{
 const opener=document.querySelector('[data-menu-open]');
 const drawer=document.querySelector('[data-drawer]');
 if(!opener||!drawer)return;
 document.addEventListener('click',event=>{
   if(event.target.closest('[data-menu-open]')){opener.setAttribute('aria-expanded','true');drawer.querySelector('[data-menu-close]')?.focus()}
   if(event.target.closest('[data-menu-close]')){opener.setAttribute('aria-expanded','false');opener.focus()}
 });
 document.addEventListener('keydown',event=>{
   if(drawer.hidden)return;
   if(event.key==='Escape'){drawer.hidden=true;document.body.classList.remove('drawer-open');opener.setAttribute('aria-expanded','false');opener.focus()}
   if(event.key==='Tab'){
     const items=Array.from(drawer.querySelectorAll('a[href],button')).filter(el=>!el.disabled);
     const first=items[0],last=items[items.length-1];
     if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus()}
     else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus()}
   }
 });
})();

(()=>{
  const root=document.querySelector('[data-mobile-product]');
  if(!root||root.dataset.enhanced)return;
  const dataElement=root.querySelector('[data-picker-data]');
  if(!dataElement)return;
  let data;
  try{data=JSON.parse(dataElement.textContent)}catch{return}
  const form=root.querySelector('form[action*="/cart/add"]');
  const native=form?.querySelector('[name="id"]');
  if(!form||!native||!data.variants.length)return;
  root.dataset.enhanced='true';
  const strings=data.strings;
  const buy=form.querySelector('button[type="submit"]');
  const payment=form.querySelector('.shopify-payment-button');
  const picker=root.querySelector('[data-product-picker]');
  const sticky=root.querySelector('[data-sticky-product]');
  const stickyBuy=sticky.querySelector('[data-sticky-buy]');
  const gallery=root.querySelector('.product__gallery');
  const media=Array.from(gallery.querySelectorAll('[data-image-id]'));
  const price=root.querySelector('.product__price');
  const selected=data.variants.find(v=>String(v.id)===native.value)||data.variants[0];
  const sizeIndex=data.options.findIndex(n=>/size|taille|talla/i.test(n));
  const explicit=new URL(location.href).searchParams.has('variant');
  const choices=selected.options.slice();
  if(sizeIndex>=0&&!explicit)choices[sizeIndex]=null;
  const groups=[];
  const optionCount=data.options[0]==='Title'&&data.variants.length===1?0:data.options.length;
  const status=document.createElement('p');
  status.className='product__picker-status';
  status.setAttribute('aria-live','polite');
  for(let i=0;i<optionCount;i++){
    const group=document.createElement('fieldset');
    group.className='product__option';
    const legend=document.createElement('legend');
    legend.textContent=data.options[i]==='Color'?'Colour':data.options[i];
    group.append(legend);
    const values=[...new Set(data.variants.map(v=>v.options[i]))];
    if(i===sizeIndex){
      const chips=document.createElement('div');chips.className='product__sizes';
      values.forEach(value=>{
        const label=document.createElement('label');label.className='product__size';
        const radio=document.createElement('input');radio.type='radio';radio.name='bn-option-'+i;radio.value=value;radio.checked=choices[i]===value;radio.setAttribute('aria-label',data.options[i]+' '+value);
        const span=document.createElement('span');span.textContent=value;
        radio.addEventListener('change',()=>{choices[i]=value;update(true)});
        label.append(radio,span);chips.append(label);
      });
      group.append(chips);
      const guide=document.createElement('a');guide.href='#bn-product-details';guide.className='product__size-guide';guide.textContent=strings.sizeGuide;
      guide.addEventListener('click',()=>{root.querySelector('.product__details').open=true});
      group.append(guide);
    }else{
      const select=document.createElement('select');select.setAttribute('aria-label',legend.textContent);
      values.forEach(value=>{const option=new Option(value,value);option.selected=choices[i]===value;select.add(option)});
      select.addEventListener('change',()=>{choices[i]=select.value;update(true)});
      group.append(select);
    }
    groups.push(group);picker.append(group);
  }
  picker.append(status);
  const details=root.querySelector('.product__details');details.id='bn-product-details';
  if(optionCount){
    if(native.tagName==='SELECT'){native.classList.add('product__native-hidden');native.setAttribute('aria-hidden','true');native.tabIndex=-1;const label=form.querySelector('label[for="'+native.id+'"]');if(label)label.classList.add('product__native-hidden')}
  }
  const controls=root.querySelector('[data-gallery-controls]');
  let currentIndex=0;
  function count(){
    if(!controls)return;
    currentIndex=Math.max(0,Math.min(media.length-1,Math.round(gallery.scrollLeft/gallery.clientWidth)));
    controls.querySelector('[data-gallery-count]').textContent=(currentIndex+1)+' / '+media.length;
    controls.querySelector('[data-gallery-prev]').disabled=currentIndex===0;
    controls.querySelector('[data-gallery-next]').disabled=currentIndex===media.length-1;
  }
  const smooth=()=>matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth';
  if(controls){
    controls.querySelector('[data-gallery-prev]').addEventListener('click',()=>gallery.scrollBy({left:-gallery.clientWidth,behavior:smooth()}));
    controls.querySelector('[data-gallery-next]').addEventListener('click',()=>gallery.scrollBy({left:gallery.clientWidth,behavior:smooth()}));
    gallery.addEventListener('scroll',count,{passive:true});window.addEventListener('resize',count);count();
  }
  function update(change){
    if(sizeIndex>=0&&choices[sizeIndex]!==null){
      const possible=data.variants.some(v=>v.available&&v.options.every((o,i)=>i===sizeIndex||o===choices[i])&&v.options[sizeIndex]===choices[sizeIndex]);
      if(!possible){choices[sizeIndex]=null;groups[sizeIndex].querySelectorAll('input').forEach(r=>r.checked=false)}
    }
    if(sizeIndex>=0)groups[sizeIndex].querySelectorAll('input').forEach(r=>r.disabled=!data.variants.some(v=>v.available&&v.options.every((o,i)=>i===sizeIndex?o===r.value:o===choices[i])));
    const needs=choices.some(v=>v===null);
    const variant=needs?null:data.variants.find(v=>v.options.every((o,i)=>o===choices[i]));
    const display=variant||data.variants.find(v=>v.available&&v.options.every((o,i)=>choices[i]===null||o===choices[i]))||selected;
    const valid=!!variant?.available;
    native.value=variant?String(variant.id):'';
    buy.disabled=!valid;
    buy.textContent=needs?strings.chooseSize:valid?strings.add:strings.soldOut;
    if(payment)payment.hidden=!valid;
    stickyBuy.disabled=!needs&&!valid;
    stickyBuy.textContent=buy.textContent;
    price.textContent=display.price;
    sticky.querySelector('[data-sticky-price]').textContent=display.price;
    sticky.querySelector('[data-sticky-selection]').textContent=choices.filter(Boolean).join(' / ');
    status.textContent=needs?strings.chooseSize:valid?choices.join(' / '):strings.unavailable;
    const buyRect=buy.getBoundingClientRect();sticky.hidden=buyRect.top>=0&&buyRect.bottom<=innerHeight;document.body.classList.add('has-mobile-product');document.body.classList.toggle('mobile-buy-visible',!sticky.hidden);
    if(display.imageId){
      const imageIndex=media.findIndex(el=>String(el.dataset.imageId)===String(display.imageId));
      if(imageIndex>=0)gallery.scrollTo({left:imageIndex*gallery.clientWidth,behavior:change?smooth():'auto'});
    }
    if(change&&variant){
      const url=new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url);
      native.dispatchEvent(new Event('change',{bubbles:true}));
    }
  }
  stickyBuy.addEventListener('click',()=>{
    if(choices.some(v=>v===null)){groups[sizeIndex]?.scrollIntoView({behavior:smooth(),block:'center'});groups[sizeIndex]?.querySelector('input:not(:disabled)')?.focus({preventScroll:true})}
    else if(!buy.disabled)form.requestSubmit(buy);
  });
  form.addEventListener('submit',event=>{if(buy.disabled){event.preventDefault();stickyBuy.click()}});
  const observer=new IntersectionObserver(entries=>{sticky.hidden=entries[0].isIntersecting;document.body.classList.toggle('mobile-buy-visible',!sticky.hidden)},{threshold:.2});
  observer.observe(buy);
  update(false);
})();
